export default function ContentsBox({index, title, comment, img, reverse, wide}){

  const r = reverse!==undefined&&reverse? true:false;
  const w = wide!==undefined&&wide? true:false;
  //const offset = index!==undefined&&index!==0 ? '40px':'0px';

  return (
    <div className={`px-mobile lg:px-0 flex flex-col lg:items-center mt-20 lg:-mt-16 ${r?'lg:flex-row-reverse':'lg:flex-row'}`}>
      <div className={`${w? 'lg:w-[530px]':'lg:w-[570px]'} ${r? 'lg:ml-10':'lg:mr-10'}`}>
        <p className="mb-10 text-2xl font-light lg:text-2xl">{title}</p>
        <p className="text-xs font-light text-gray-600 lg:text-base"
          dangerouslySetInnerHTML={{__html:comment}}></p>
      </div>
      <div className={`${w? 'lg:w-[630px]':'lg:w-[590px]'} z-10 mt-10 lg:mt-0`}>
        <img src={img} className={`${w? 'lg:w-[630px]':'lg:w-[590px]'}`} alt='optimzers'/>
      </div>
    </div>
  );
}